import React from 'react'
import { Checkbox, Typography } from 'antd'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { StyledNoMarginFormItem } from '../../../core/components/styled'

import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormItemLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

const FormCheckbox = ({
  name,
  label,
  rules,
  disabled,
  showColon,
  labelAbove,
}) => {
  if (isNil(label)) {
    return (
      <StyledNoMarginFormItem name={name} rules={rules} valuePropName="checked">
        <Checkbox disabled={disabled} />
      </StyledNoMarginFormItem>
    )
  }

  return (
    <StyledNoMarginFormItem
      name={name}
      valuePropName="checked"
      rules={rules}
      label={
        <Typography.Text>
          {formatFormItemLabel(label, showColon)}
        </Typography.Text>
      }
      labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
    >
      <Checkbox disabled={disabled} />
    </StyledNoMarginFormItem>
  )
}

FormCheckbox.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  disabled: PropTypes.bool,
  labelAbove: PropTypes.bool,
  showColon: PropTypes.bool,
}

FormCheckbox.defaultProps = {
  label: '',
  rules: undefined,
  disabled: false,
  labelAbove: false,
  showColon: false,
}

export default FormCheckbox
